export const STORAGE_KEY_DYNAMIC_REDIRECTION = 'DYN-REDIR--';
export const STORAGE_KEY_DYNAMIC_USER_ID = 'DYN-USERID--';
export const STORAGE_KEY_DYNAMIC_CLICK_ID = 'DYN-CLICKID--';
export const STORAGE_KEY_DYNAMIC_USER_LAST_EBON_INFO_ID = 'DYN-LASTEBONINFO--';
export const STORAGE_KEY_DYNAMIC_SCORE_HASH = 'DYN-SCHA--';
export const STORAGE_KEY_DYNAMIC_SOURCE = 'DYN-SOURCE--';

export const STORAGE_KEY_FAILURE_BANK_TRANSFER_ENABLED = 'failureBankTransferEnabled';



// WEBPACK FOOTER //
// ./src/constants/storage.js